import React, { useState, useEffect } from 'react';
import { Col, Row, Card, Input, Select, Spin, DatePicker } from 'antd';
import { DATE_FORMAT_YYYY_MM_dd, DATE_FORMAT_YYYY_MM_dd_Combined } from 'cl-library/dist/constants/DateConstant';
import DataDisplayWidget from 'cl-library/dist/components/shared-components/DataDisplayWidget';
import { SearchOutlined, UserSwitchOutlined } from '@ant-design/icons';
import config from "../../config.json";
import axios from 'axios';
import utils from '../utils/index';
import moment from 'moment';
import TableData from './TableData';
import ErrorPage from '../error-views/errorPage'
const { Option } = Select;
const date = new Date();
let year = date.getFullYear();
let month = ("0" + (date.getMonth() + 1)).slice(-2);
let day = ("0" + date.getDate()).slice(-2);
let today = `${year}-${month}-${day}`;

const EnglishLabelChange = () => {
  const cl = localStorage.getItem("CL");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(true);
  const [apiError, setapiError] = useState(null);

  const [allParentData, setAllParentData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [allRM] = useState([]);
  const [newAllRM, setNewAllRM] = useState([]);
  const [filterRM, setFilterRM] = useState([]);

  const [selectRM, setSelectRM] = useState("All");
  const [typeData, setTypeData] = useState("All");
  let [start, setStart] = useState(undefined);//Startdate
  const [end, setEnd] = useState(today);//enddate
  const TypeList = ['Done', 'Pending', 'Duplicate']
  useEffect(() => {
    callStudentDetails();
  }, []);

  function callStudentDetails() {
    let englishLabelRequestUrl = config.englishLabelRequest + cl;

    axios.get(englishLabelRequestUrl, { headers: { 'Authorization': token } })
      .then(resp => {
        if (resp.data.status === "error") setapiError(resp.data);
        else {
          resp.data.map(obj => {
            obj.Date = dateFormate(obj.Date);
            if (!obj.status) {
              obj.status = "Pending"
            }
          })
          let rmList = resp.data.reduce((unique, o) => {
            if (!unique.some(obj => obj.rm_code === o.rm_code)) {
              unique.push(o);
            }
            return unique;
          }, []);
          setFilterRM(rmList);
          setStart(new Date(resp.data[0].Date))
          setNewAllRM(rmList)
          setAllParentData(resp.data);
          setAllData(resp.data);
          setSearchData(resp.data);
          setLoading(false);

        }
      }, err => {
        let obj = { "status": "error", "message": "Network Error" };
        if (err.response) setapiError(err.response);
        else setapiError(obj);
      });

  }

  function dateFormate(changeDate) {
    let date = new Date(changeDate)
    let year = date.getFullYear();
    let month = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    let todayDate = `${year}-${month}-${day}`;
    return todayDate;
  }

  const onSearch = e => {
    const value = e.currentTarget.value;
    const searchdata = utils.wildCardSearch(searchData, value)
    setAllData(searchdata);
    let rmList = searchdata.reduce((unique, o) => {
      if (!unique.some(obj => obj.rm_code === o.rm_code)) {
        unique.push(o);
      }
      return unique;
    }, []);
    setFilterRM(rmList);
  }

  const handleShowRM = value => {
    let details = showTableData("status");
    setSelectRM(value);
    if (value !== 'All') {
      const key = 'rm_code'
      const data = utils.filterArray(details, key, value)
      setAllData(data);
      setSearchData(data);
      let rmList = data.reduce((unique, o) => {
        if (!unique.some(obj => obj.rm_code === o.rm_code)) {
          unique.push(o);
        }
        return unique;
      }, []);
      setFilterRM(rmList);
    }
    else {
      setAllData(details);
      setSearchData(details);
      setFilterRM(allRM);
    }
  }

  const handleShowType = value => {
    let details = showTableData("Status");
    setTypeData(value);
    if (value !== 'All') {
      const key = 'status'
      const data = utils.filterArray(details, key, value)
      setAllData(data);
      setSearchData(data);
      let rmList = data.reduce((unique, o) => {
        if (!unique.some(obj => obj.rm_code === o.rm_code)) {
          unique.push(o);
        }
        return unique;

      }, []);
      setFilterRM(rmList);
    }
    else {
      setAllData(details);
      setSearchData(details);
      setFilterRM(allRM);
    }
  }

  function filterDate(str, dateString) {
    let details = showTableData("Status");

    if (str === "end" && dateString) {
      setEnd(dateFormate(dateString));
      let startDate = typeof start === "object" ? dateFormate(start) : start;
      setStart(startDate);

      let filterData = details.filter(obj => obj.Date >= startDate && obj.Date <= dateString);
      let rmList = filterData.reduce((unique, o) => {
        if (!unique.some(obj => obj.rm_code === o.rm_code)) {
          unique.push(o);
        }
        return unique;
      }, []);

      setFilterRM(rmList);
      setAllData(filterData);
      setSearchData(filterData);
    }
    else if (str === "start" && dateString) {
      setStart(dateString);

      let filterData = details.filter(obj => obj.Date >= dateString && obj.Date <= end);
      let rmList = filterData.reduce((unique, o) => {
        if (!unique.some(obj => obj.rm_code === o.rm_code)) {
          unique.push(o);
        }
        return unique;
      }, []);

      setFilterRM(rmList);
      setAllData(filterData);
      setSearchData(filterData);
    }
    else {
      setAllData(details);
      setSearchData(details);
    }
  }


  function showTableData(str) {
    let startDate = typeof start === "object" ? dateFormate(start) : start;
    setStart(startDate);
    let data = str === "date" ? allParentData : allParentData.filter(obj => obj.Date >= startDate && obj.Date <= end);
    if (str === "index" || str === "date") {
      if (typeData !== "All") {
        data = utils.filterArray(data, str, typeData);
      }
    }

    if (str === "Status" || str === "date") {
      if (selectRM !== "All") {
        data = utils.filterArray(data, 'RM_code', selectRM);
      }
    }

    return data;
  }


  if (apiError) {
    return <ErrorPage details={apiError} />
  } else if (loading) {
    return <Spin tip="Loading.."></Spin>
  } else {
    return (
      <>
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={16} xl={16} xxl={16}>
            <Card title="Filter">
              <Row gutter={[8, 8]}>
                <Col xs={24} sm={24} md={24} lg={9} xl={9} xxl={9} >
                  <Input placeholder="Search" style={{ width: '90%' }} prefix={<SearchOutlined />} onChange={e => onSearch(e)} />
                </Col>
                {start ?
                  <Col xs={24} sm={24} md={24} lg={15} xl={15} xxl={15}>
                    <Row gutter={[4, 4]}>
                      <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                        <label><b>Date From : </b></label>
                        <DatePicker
                          defaultValue={moment(start, DATE_FORMAT_YYYY_MM_dd)}

                          onChange={(momentDate, dateString) => filterDate("start", dateString)}
                          placeholder='Start Date'
                        />
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                        <label><b>&nbsp;To : </b></label>
                        <DatePicker
                          defaultValue={moment(date, DATE_FORMAT_YYYY_MM_dd_Combined)}

                          onChange={(momentDate, dateString) => filterDate("end", dateString)}
                          placeholder='End Date'
                        />
                      </Col>
                    </Row>
                  </Col>
                  : <></>
                }
              </Row>
              <Row gutter={16}  >
                <Col className="mt-4" xs={12} sm={12} md={12} lg={9} xl={9} xxl={9}>
                  <label><b>RMCode: </b></label>&nbsp;
                  <Select
                    showSearch
                    style={{ width: '70%' }}
                    placeholder="Search or Select RM Code"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                    }
                    onChange={handleShowRM}
                  ><Option value="All">All</Option>
                    {
                      newAllRM.map(item => (<Option key={item.rm_code} value={item.rm_code}>{item.rm_code}</Option>))
                    }
                  </Select>
                </Col>
                <Col className="mt-4" xs={12} sm={12} md={12} lg={15} xl={15} xxl={15}>
                  <label><b>Status: </b></label>&nbsp;
                  <Select
                    style={{ width: '40%' }}
                    defaultValue="All"
                    onChange={handleShowType}>
                    <Option value="All">All</Option>
                    {TypeList.map(elm => <Option key={elm} value={elm}>{elm}</Option>)}
                  </Select>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
            <DataDisplayWidget
              icon={<UserSwitchOutlined />}
              value={allData.length}
              title="Total Student"
              color="cyan"
              size={"20"}
              vertical={true}
              avatarSize={30}
              cardHeight={194}

            />
          </Col>

          <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} >
            <DataDisplayWidget
              icon={<UserSwitchOutlined />}
              value={filterRM.length}
              title="Total RM"
              color="volcano"
              size={"20"}
              vertical={true}
              avatarSize={30}
              cardHeight={194}

            />
          </Col>
        </Row>
        <TableData data={allData} />
      </>
    )
  }
}
export default EnglishLabelChange
